import { createApp } from 'vue';
import { initIcons } from './icons';
import App from './App.vue';
import { serviceRegistry } from '@arcual/lib-app-platform';
import router from './router';
import { i18n } from './i18n';
import { createPinia } from 'pinia';
import VueGtag from 'vue-gtag';
import Hotjar from 'vue-hotjar';
import { env } from '@/constants';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { vMaska } from 'maska';
import * as Sentry from '@sentry/vue';
import { platformHttpServiceConfiguration } from '@/services/PlatformHttpServiceConfiguration';
import { loadUsetifulScript } from 'usetiful-sdk';

serviceRegistry.initServices(platformHttpServiceConfiguration);

initIcons();

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const app = createApp(App);

const pinia = createPinia();

app.use(pinia);
pinia.use(piniaPluginPersistedstate);

// init authentication AFTER pinia as we first need to bootstrap the authorization store for managing auth token reactivity.
serviceRegistry.initAuthentication();

app.use(router);
app.use(i18n);
app.use(
  VueGtag,
  {
    disableScriptLoad: false,
    config: {
      id: 'G-6KWKB0V3V1',
    },
    enabled: env.VITE_ENV === 'production',
  },
  router,
);

app.use(Hotjar, {
  id: '3921158', // Hotjar Site ID
  isProduction: env.VITE_ENV === 'production',
});

if (env.VITE_FEATURE_SENTRY_ENABLED) {
  const integrations = [Sentry.browserTracingIntegration(), Sentry.replayIntegration()];

  if (env.VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED) {
    integrations.push(
      Sentry.feedbackIntegration({
        colorScheme: 'system',
        showBranding: false,
        isEmailRequired: true,
        autoInject: false,
      }),
    );
  }

  const sentryConfig = {
    app,
    dsn: env.VITE_SENTRY_INGEST_URL,
    environment: env.VITE_ENV,
    release: env.VITE_PACKAGE_VERSION,
    integrations,
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/platform-api.*\.arcual\.art/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  };

  Sentry.init(sentryConfig);
}

app.directive('maska', vMaska);

if (env.VITE_USETIFUL_ENABLED && env.VITE_USETIFUL_TOKEN) {
  loadUsetifulScript(env.VITE_USETIFUL_TOKEN);
  console.info('Usetiful enabled');
}

app.mount('#app');

console.info(`v${env.VITE_PACKAGE_VERSION}`);
